module.exports = __webpack_public_path__ + "static/media/inktoberScarecrow.ad377333.gif";